<script>
  import { modal } from 'vue-strap';
  import moment from 'moment';
  import servico from '../servico';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';

  export default {
    components: { modal, AdicionarArquivos },
    props: {
      mostrar: {
        type: Boolean,
        required: true,
      },
      id: {
        default: null,
      },
    },
    data() {
      return {
        solicitacao: null,
        prestacao: null,
        arquivos: [],
        carregando: false,
        carregandoArquivos: false,
        salvando: false,
        descricaoAtividade: '',
        reenviando: false,
        aba: 'dados',
      }
    },
    computed: {
      show() {
        return this.mostrar;
      },
      aceita() {
        return !!(this.prestacao && this.prestacao.dataHoraAceitoPrestConta);
      },
      rejeitada() {
        return !!(this.prestacao && !this.aceita && this.prestacao.motivoRejeicao);
      },
      enviada() {
        return !!(this.prestacao && this.prestacao.dataHoraAtividade && !this.aceita && !this.rejeitada);
      },
      aPrestar() {
        return !!(this.prestacao && !this.aceita && !this.rejeitada && !this.enviada);
      },
      podeEditar() {
        return this.rejeitada || this.aPrestar || (this.enviada && this.reenviando);
      },
      diasParaPrazo() {
        if (!this.prestacao || !this.prestacao.dataLimitePrestacao) return null;

        return moment(String(this.prestacao.dataLimitePrestacao)).startOf('day').diff(moment().startOf('day'), 'days');
      },
      textoDias() {
        const dias = this.diasParaPrazo;

        if (dias === null) return '';
        if (dias < 0) return -dias === 1 ? 'venceu há 1 dia' : `venceu há ${-dias} dias`;
        if (dias === 0) return 'vence hoje';

        return dias === 1 ? 'falta 1 dia' : `faltam ${dias} dias`;
      },
      prazo() {
        return this.prestacao && this.prestacao.dataLimitePrestacao ? this.formatarData(this.prestacao.dataLimitePrestacao) : '';
      },
      faixa() {
        const prestacao = this.prestacao;

        if (!prestacao) return null;

        const conferidoPor = prestacao.conferidoPor ? ` por ${prestacao.conferidoPor}` : '';
        const prestadoPor = prestacao.prestadoPor ? ` por ${prestacao.prestadoPor}` : '';

        if (this.aceita) {
          return {
            classe: 'faixa-aceita',
            icone: 'fa-check-circle',
            titulo: `Aceita pela fundação em ${this.formatarData(prestacao.dataHoraAceitoPrestConta)}${conferidoPor}.`,
            texto: 'Nada mais a fazer nesta solicitação.',
          };
        }

        if (this.rejeitada) {
          return {
            classe: 'faixa-rejeitada',
            icone: 'fa-times-circle',
            titulo: `Rejeitada pela fundação${conferidoPor}.`,
            texto: this.prazo ? `Corrija e reenvie até ${this.prazo}.` : 'Corrija e reenvie.',
            motivo: prestacao.motivoRejeicao,
          };
        }

        if (this.enviada && !this.reenviando) {
          return {
            classe: 'faixa-enviada',
            icone: 'fa-clock-o',
            titulo: `Enviada em ${this.formatarDataHora(prestacao.dataHoraAtividade)}${prestadoPor}.`,
            texto: 'Aguardando conferência da fundação.',
          };
        }

        const vencida = this.diasParaPrazo !== null && this.diasParaPrazo < 0;
        const titulo = this.prazo
          ? `${vencida ? 'O prazo para prestar contas venceu em' : 'Prazo para prestar contas:'} ${this.prazo} (${this.textoDias}).`
          : 'Sem prazo definido para prestar contas.';

        return {
          classe: vencida ? 'faixa-rejeitada' : 'faixa-prestar',
          icone: vencida ? 'fa-exclamation-triangle' : 'fa-clock-o',
          titulo,
          texto: 'Descreva a atividade e anexe ao menos um comprovante.',
        };
      },
      etapas() {
        const prestacao = this.prestacao;

        if (!prestacao) return [];

        const atividade = prestacao.dataHoraAtividade ? `em ${this.formatarDataCurta(prestacao.dataHoraAtividade)}` : '';
        const aceite = prestacao.dataHoraAceitoPrestConta ? `em ${this.formatarDataCurta(prestacao.dataHoraAceitoPrestConta)}` : '';
        const ate = this.prazo ? `até ${this.prazo.substr(0, 5)}` : '';
        const vencida = this.diasParaPrazo !== null && this.diasParaPrazo < 0;

        if (this.aceita) {
          return [
            { nome: 'Prestar contas', sub: atividade, classe: 'etapa-feita' },
            { nome: 'Fundação confere', sub: aceite, classe: 'etapa-feita' },
            { nome: 'Aceita', sub: aceite, classe: 'etapa-feita' },
          ];
        }

        if (this.rejeitada) {
          return [
            { nome: 'Prestar contas', sub: ate, classe: 'etapa-ruim' },
            { nome: 'Fundação confere', sub: 'rejeitou', classe: 'etapa-ruim' },
            { nome: 'Aceita', sub: '', classe: '' },
          ];
        }

        if (this.enviada && !this.reenviando) {
          return [
            { nome: 'Prestar contas', sub: atividade, classe: 'etapa-feita' },
            { nome: 'Fundação confere', sub: 'em conferência', classe: 'etapa-atual-info' },
            { nome: 'Aceita', sub: '', classe: '' },
          ];
        }

        return [
          { nome: 'Prestar contas', sub: ate, classe: vencida ? 'etapa-ruim' : 'etapa-atual' },
          { nome: 'Fundação confere', sub: '', classe: '' },
          { nome: 'Aceita', sub: '', classe: '' },
        ];
      },
      abas() {
        return [
          { valor: 'dados', label: 'Dados da solicitação' },
          { valor: 'descricao', label: 'Descrição da atividade' },
          { valor: 'arquivos', label: `Arquivos (${this.arquivos.length})` },
        ];
      },
      textoBotaoEnviar() {
        return this.rejeitada ? 'Reenviar à fundação' : 'Enviar à fundação';
      },
    },
    methods: {
      carregar() {
        if (!this.id) return;

        this.carregando = true;

        Promise.all([
          servico.obterPorId(this.id),
          servico.prestacao(this.id),
        ])
          .then(([solicitacao, prestacao]) => {
            this.solicitacao = solicitacao;
            this.prestacao = prestacao;
            this.descricaoAtividade = prestacao.descricaoAtividade || '';
            this.aba = this.rejeitada || this.aPrestar ? 'descricao' : 'dados';
            this.carregando = false;
          })
          .catch(erro => {
            this.carregando = false;
            this.$mensagemErro(erro, 'Erro ao carregar a prestação de contas.');
          });

        this.carregarArquivos();
      },
      carregarArquivos() {
        this.carregandoArquivos = true;

        return servico.arquivos(this.id)
          .then(arquivos => {
            this.arquivos = arquivos || [];
            this.carregandoArquivos = false;
          })
          .catch(() => {
            this.arquivos = [];
            this.carregandoArquivos = false;
          });
      },
      limpar() {
        this.solicitacao = null;
        this.prestacao = null;
        this.arquivos = [];
        this.carregando = false;
        this.carregandoArquivos = false;
        this.salvando = false;
        this.descricaoAtividade = '';
        this.reenviando = false;
        this.aba = 'dados';
        this.errors.clear();
      },
      sair() {
        this.$refs.modal.action(false, 3);
      },
      nomeArquivo(arquivo) {
        return arquivo.split('/').pop().split('\\').pop();
      },
      baixar(arquivo) {
        return servico.download(this.id, this.nomeArquivo(arquivo))
          .catch(() => toastr.error('Ocorreu um erro ao baixar o arquivo.'));
      },
      tipo(tipoReembolso) {
        if (tipoReembolso === 0) return 'Passagem';
        if (tipoReembolso === 1) return 'Diária';

        return 'Adiantamento';
      },
      formatarData(data) {
        return data ? moment(String(data)).format('DD/MM/YYYY') : '';
      },
      formatarDataCurta(data) {
        return data ? moment(String(data)).format('DD/MM') : '';
      },
      formatarDataHora(data) {
        return data ? moment(String(data)).format('DD/MM/YYYY [às] HH:mm') : '';
      },
      novaPrestacao() {
        this.reenviando = true;
        this.aba = 'descricao';
      },
      enviar() {
        this.$validator.validateAll()
          .then(valido => {
            if (!valido) {
              this.aba = 'descricao';
              return;
            }

            const adicionar = this.$refs.adicionarArquivos;

            if (!adicionar || !adicionar.existeArquivo()) {
              this.aba = 'arquivos';
              toastr.warning('É obrigatório anexar pelo menos um arquivo na prestação de contas.');
              return;
            }

            const formData = new FormData();
            formData.append('descricaoAtividade', this.descricaoAtividade);

            adicionar.arquivos
              .filter(arquivo => arquivo)
              .forEach(arquivo => formData.append('arquivos', arquivo));

            this.salvando = true;

            return servico.salvarAtividade(this.id, formData)
              .then(() => {
                this.salvando = false;
                toastr.success('Prestação de contas enviada à fundação.');
                this.$emit('enviado');
                this.sair();
              });
          })
          .catch(erro => {
            this.salvando = false;
            this.$mensagemErro(erro, 'Erro ao registrar a prestação de contas.');
          });
      },
    },
  }
</script>

<template>
  <div>
    <modal ref="modal"
           class="modal-centralizado"
           :value="show"
           effect="fade"
           :large="true"
           :backdrop="false"
           @opened="carregar"
           @closed="limpar(), $emit('fechado')">
      <div slot="modal-header" class="modal-header">
        Prestação de contas<template v-if="solicitacao"> - Solicitação #{{ solicitacao.idSolicitacaoReembolso }}</template>
      </div>

      <div v-if="carregando" class="text-center">
        <i class="fa fa-spinner fa-pulse"></i> Carregando...
      </div>

      <div v-if="!carregando && solicitacao && prestacao">
        <div v-if="faixa" :class="['faixa-situacao', faixa.classe]">
          <div>
            <i :class="['fa', faixa.icone]"></i>
            <strong>{{ faixa.titulo }}</strong>
            {{ faixa.texto }}
          </div>
          <div v-if="faixa.motivo" class="faixa-motivo">Motivo: {{ faixa.motivo }}</div>
        </div>

        <div class="etapas">
          <div v-for="(etapa, indice) in etapas" :key="indice" :class="['etapa', etapa.classe]">
            <div class="etapa-barra"></div>
            <span class="etapa-nome">{{ etapa.nome }} <span class="etapa-sub">{{ etapa.sub }}</span></span>
          </div>
        </div>

        <ul class="nav nav-tabs abas-prestacao">
          <li v-for="item in abas" :key="item.valor" :class="{ active: aba === item.valor }">
            <a href="#" @click.prevent="aba = item.valor">{{ item.label }}</a>
          </li>
        </ul>

        <div class="conteudo-aba">
          <div v-show="aba === 'dados'">
            <div class="row">
              <div class="col-sm-3">
                <label class="control-label block">Número</label>
                <p class="form-control-static">{{ solicitacao.idSolicitacaoReembolso }}</p>
              </div>
              <div class="col-sm-3">
                <label class="control-label block">Tipo</label>
                <p class="form-control-static">{{ tipo(solicitacao.tipoReembolso) }}</p>
              </div>
              <div class="col-sm-3">
                <label class="control-label block">Data solicitação</label>
                <p class="form-control-static">{{ solicitacao.dataSolicitacao | formatarNumeroEmData }}</p>
              </div>
              <div class="col-sm-3">
                <label class="control-label block">Prazo prestação</label>
                <p class="form-control-static">{{ prazo || '---' }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <label class="control-label block">Beneficiário</label>
                <p class="form-control-static">{{ solicitacao.documentoTerceiro || '---' }} - {{ solicitacao.nomeTerceiro || '---' }}</p>
              </div>
              <div class="col-sm-6">
                <label class="control-label block">Projeto</label>
                <p class="form-control-static">{{ solicitacao.projeto ? solicitacao.projeto.nomeProjeto : '---' }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <label class="control-label block">Observação</label>
                <p class="form-control-static texto-longo">{{ solicitacao.observacao || '---' }}</p>
              </div>
            </div>
          </div>

          <div v-show="aba === 'descricao'">
            <div class="form-group" v-if="!podeEditar">
              <label class="control-label block">Descrição da atividade</label>
              <p class="form-control-static texto-longo">{{ prestacao.descricaoAtividade || '---' }}</p>
            </div>

            <div class="form-group required"
                 v-if="podeEditar"
                 :class="{ 'has-error': errors.has('descricaoAtividade') }">
              <label class="control-label" for="descricao-atividade">Descrição da atividade</label>
              <textarea id="descricao-atividade"
                        class="form-control"
                        rows="8"
                        v-model="descricaoAtividade"
                        placeholder="Descreva a atividade realizada"
                        data-vv-name="descricaoAtividade"
                        data-vv-as="descrição da atividade"
                        v-validate="'required'"></textarea>
              <p class="text-danger" v-show="errors.has('descricaoAtividade')">
                {{ errors.first('descricaoAtividade') }}
              </p>
            </div>
          </div>

          <div v-show="aba === 'arquivos'">
            <div class="table-responsive">
              <table class="table table-bordered tabela-arquivos">
                <thead>
                  <tr>
                    <th>Arquivo</th>
                    <th class="coluna-baixar"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(arquivo, indice) in arquivos" :key="indice">
                    <td>{{ nomeArquivo(arquivo) }}</td>
                    <td class="coluna-baixar">
                      <button type="button" class="btn btn-default btn-baixar" @click="baixar(arquivo)">
                        <i class="fa fa-download"></i> Baixar
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!arquivos.length && !carregandoArquivos">
                    <td colspan="2" class="text-center">Nenhum arquivo enviado.</td>
                  </tr>
                  <tr v-show="carregandoArquivos">
                    <td colspan="2">
                      <i class="fa fa-spinner fa-pulse"></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="form-group required area-anexar" v-if="podeEditar">
              <label class="control-label">Anexar comprovantes</label>
              <adicionar-arquivos ref="adicionarArquivos"></adicionar-arquivos>
            </div>
          </div>
        </div>
      </div>

      <div slot="modal-footer" class="modal-footer">
        <button type="button"
                class="btn btn-primary"
                v-if="prestacao && podeEditar"
                :disabled="salvando"
                @click="enviar">
          <i :class="['fa', salvando ? 'fa-spinner fa-pulse' : 'fa-paper-plane']"></i> {{ textoBotaoEnviar }}
        </button>
        <button type="button"
                class="btn btn-nova-prestacao"
                v-if="enviada && !reenviando"
                @click="novaPrestacao">
          <i class="fa fa-refresh"></i> Enviar nova prestação
        </button>
        <button type="button" class="btn btn-sair" :disabled="salvando" @click="sair">
          <i class="fa fa-sign-out"></i> Sair
        </button>
      </div>
    </modal>
  </div>
</template>

<style scoped>
  .faixa-situacao {
    border-left: 5px solid;
    border-radius: 4px;
    padding: 10px 14px;
    margin-bottom: 12px;
  }

  .faixa-situacao .fa {
    margin-right: 4px;
  }

  .faixa-motivo {
    margin-top: 4px;
  }

  .faixa-rejeitada {
    background-color: #fdecea;
    border-left-color: #d9534f;
    color: #6b1f1c;
  }

  .faixa-prestar {
    background-color: #fcf8e3;
    border-left-color: #f0ad4e;
    color: #6a4c12;
  }

  .faixa-enviada {
    background-color: #e8f1f8;
    border-left-color: #1c84c6;
    color: #164a6e;
  }

  .faixa-aceita {
    background-color: #dff0d8;
    border-left-color: #5cb85c;
    color: #2b542c;
  }

  .etapas {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 10px;
  }

  .etapa-barra {
    height: 5px;
    border-radius: 3px;
    background-color: #e1e4e7;
    margin-bottom: 4px;
  }

  .etapa-nome {
    font-size: 11px;
    color: #8a8d90;
  }

  .etapa-sub {
    font-weight: 400;
    color: #6b6e70;
  }

  .etapa-feita .etapa-barra {
    background-color: #3c8d3c;
  }

  .etapa-feita .etapa-nome {
    color: #2f6b2f;
    font-weight: 600;
  }

  .etapa-atual .etapa-barra {
    background-color: #f0ad4e;
  }

  .etapa-atual .etapa-nome {
    color: #6a4c12;
    font-weight: 700;
  }

  .etapa-atual-info .etapa-barra {
    background-color: #1c84c6;
  }

  .etapa-atual-info .etapa-nome {
    color: #1a5a85;
    font-weight: 700;
  }

  .etapa-ruim .etapa-barra {
    background-color: #c9302c;
  }

  .etapa-ruim .etapa-nome {
    color: #a33a37;
    font-weight: 700;
  }

  .abas-prestacao {
    margin-top: 6px;
  }

  .conteudo-aba {
    padding-top: 15px;
    min-height: 260px;
  }

  .form-control-static {
    margin-bottom: 10px;
    word-break: break-word;
  }

  .texto-longo {
    white-space: pre-wrap;
  }

  .coluna-baixar {
    width: 1%;
    white-space: nowrap;
    text-align: center;
  }

  .btn-baixar {
    height: 30px;
  }

  .area-anexar {
    margin-top: 10px;
  }

  .modal-footer .btn {
    height: 34px;
  }

  .btn-nova-prestacao {
    background: #fff;
    border: 1px solid #148a73;
    color: #126e5c;
  }

  .btn-nova-prestacao:hover {
    background: #eaf6f2;
    color: #126e5c;
  }

  .btn-sair {
    background: #fdf1f1;
    border: 1px solid #e4d7d7;
    color: #a13c3c;
    font-weight: 600;
  }

  .btn-sair:hover {
    background: #fbe7e7;
    border-color: #d9c2c2;
    color: #a13c3c;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso-atividade/componentes/ModalPrestacaoContas.vue